<dx-data-grid
  id="fieldsInterventionsGridContainer"
  [ngStyle]="gridCss"
  [dataSource]="ds"
  [showRowLines]="true"
  [remoteOperations]="{ paging: true, sorting: false, filtering: true }"
  [allowColumnReordering]="true"
  [allowColumnResizing]="false"
  [rowAlternationEnabled]="true"
  [columnHidingEnabled]="false"
  [columnAutoWidth]="true"
  [errorRowEnabled]="false"
  [stateStoring]="{ enabled: false }"
  (onRowDblClick)="showInterventionDetails($event)"
  (onToolbarPreparing)="onToolbarPreparing($event)"
  (onExporting)="onExporting($event)"
  (onRowUpdating)="onTrailerUpdate($event)"
  [libGridTitle]="{ text: 'Interventions sur Parcelles' }"
  [showBorders]="false"
>
  <dxi-column
    caption="ID"
    dataField="id"
    [allowEditing]="false"
    [formItem]="{ visible: false }"
    dataType="number"
  >
  </dxi-column>

  <dxi-column
    caption="Type"
    [width]="150"
    dataField="intervention_source"
    [allowEditing]="false"
    cellTemplate="typeTemplate">
    <div *dxTemplate="let cellInfo of 'typeTemplate'">
      <lib-badge [color]="getInterventionTypeColor(cellInfo.value)">
        {{getInterventionTypeLabel(cellInfo.value)}}
      </lib-badge>
    </div>
  </dxi-column>

  <dxi-column [width]="350" caption="Actions" [allowEditing]="false" cellTemplate="actionsTemplate">
    <div *dxTemplate="let cellInfo of 'actionsTemplate'" class="flex gap-1">
      <dx-button
        *ngIf="canValidate && isPendingValidation(cellInfo)"
        text="Valider"
        icon="check"
        type="success"
        stylingMode="contained"
        [height]="30"
        hint="Valider l'intervention"
        (onClick)="validateIntervention(cellInfo)">
      </dx-button>
      <dx-button
        *ngIf="canValidate && cellInfo.data.status === 'validated'"
        text="Modifier"
        icon="edit"
        type="default"
        stylingMode="contained"
        [height]="30"
        hint="Modifier la validation"
        (onClick)="validateIntervention(cellInfo)">
      </dx-button>
      <dx-button
        *ngIf="canReject && isPendingValidation(cellInfo)"
        text="Rejeter"
        icon="close"
        type="danger"
        stylingMode="contained"
        [height]="30"
        hint="Rejeter l'intervention"
        (onClick)="rejectIntervention(cellInfo)">
      </dx-button>
      <dx-button
        *ngIf="canRevoke && isValidatedOrRejected(cellInfo)"
        text="Révoquer"
        icon="undo"
        type="default"
        stylingMode="contained"
        [height]="30"
        hint="Révoquer l'intervention"
        (onClick)="revokeIntervention(cellInfo)">
      </dx-button>
      <dx-button
        *ngIf="isTrailerForRating(cellInfo)"
        [text]="cellInfo.data.data_accuracy_rating ? 'Modifier' : 'Évaluer'"
        icon="edit"
        type="default"
        stylingMode="contained"
        [height]="30"
        [hint]="cellInfo.data.data_accuracy_rating ? 'Modifier l\'évaluation' : 'Évaluer l\'intervention'"
        (onClick)="openRatingDialog(cellInfo)">
      </dx-button>
      <dx-button
        *ngIf="canDeleteManualIntervention(cellInfo)"
        text="Supprimer"
        icon="trash"
        type="danger"
        stylingMode="contained"
        [height]="30"
        hint="Supprimer l'intervention manuelle"
        (onClick)="deleteManualIntervention(cellInfo)">
      </dx-button>
      <dx-button
        icon="chart"
        type="default"
        stylingMode="text"
        [height]="30"
        hint="Voir les détails"
        (onClick)="showInterventionDetails(cellInfo)">
      </dx-button>
    </div>
  </dxi-column>

  <dxi-column caption="Date et Heures" [allowEditing]="false">
    <dxi-column
      caption="Date"
      dataField="start_time"
      name="start_time_date"
      sortOrder="desc"
      format="shortDate"
      dataType="date"
      [allowEditing]="false"
    >
    </dxi-column>

    <dxi-column
      caption="Début"
      name="start_time_time"
      dataField="start_time"
      format="shortTime"
      dataType="date"
      [allowEditing]="false"
    >
    </dxi-column>

    <dxi-column
      caption="Fin"
      cellTemplate="endTimeTemplate"
      format="shortTime"
      dataType="date"
      [allowEditing]="false"
    >
      <div *dxTemplate="let cellInfo of 'endTimeTemplate'">
        <span *ngIf="isTrailer(cellInfo.data)">
          <span *ngIf="cellInfo.data.update_time">{{ cellInfo.data.update_time | date:'shortTime' }}</span>
          <span *ngIf="!cellInfo.data.update_time && cellInfo.data.stop_time">{{ cellInfo.data.stop_time | date:'shortTime' }}</span>
        </span>
        <span *ngIf="isReconstructed(cellInfo.data)">{{ cellInfo.data.stop_time | date:'shortTime' }}</span>
      </div>
    </dxi-column>
  </dxi-column>

  <dxi-column
    [visible]="columnFocusCurrentModes.includes('trailer')"
    name="vehicle_column_group"
    caption="Véhicule"
    [allowEditing]="false"
  >
    <dxi-column caption="Nom" dataField="tractor_name" [allowEditing]="false"> </dxi-column>
    <dxi-column
      caption="Puissance"
      [width]="80"
      dataField="tractor_engine_power"
      [allowEditing]="false"
    >
    </dxi-column>
    <dxi-column 
      caption="Outil" 
      dataField="trailer_name"
      [allowEditing]="canEditTrailer"
      cellTemplate="trailerCellTemplate"
      editCellTemplate="trailerEditor">
      <!-- Display template with edit indicator -->
      <div *dxTemplate="let cellInfo of 'trailerCellTemplate'" class="editable-cell">
        <span>{{ cellInfo.value }}</span>
        <i *ngIf="canEditTrailer(cellInfo.data)" 
           class="dx-icon-edit edit-indicator" 
           title="Cliquez pour modifier l'outil"></i>
      </div>
      <!-- Edit template -->
      <div *dxTemplate="let cellInfo of 'trailerEditor'">
        <dx-select-box
          [dataSource]="trailersDataSource"
          displayExpr="name"
          valueExpr="id"
          [value]="cellInfo.data?.trailer_id"
          (onValueChanged)="onTrailerSelectChange($event, cellInfo)"
          [searchEnabled]="true"
          searchMode="contains"
          [searchExpr]="['name', 'code']"
          placeholder="Sélectionner un outil">
        </dx-select-box>
      </div>
    </dxi-column>
    <dxi-column
      caption="Largeur"
      [width]="80"
      [customizeText]="widthUnit"
      dataField="trailer_width"
      [allowEditing]="false"
    >
    </dxi-column>
  </dxi-column>

  <dxi-column
    [visible]="columnFocusCurrentModes.includes('field')"
    name="field"
    caption="Parcelle"
    [allowEditing]="false"
  >
    <dxi-column caption="Nom" dataField="field.name" [allowEditing]="false"> </dxi-column>

    <dxi-column
      caption="Opération"
      [width]="100"
      dataField="trailer_operation_type"
      [allowEditing]="false"
    >
    </dxi-column>

    <dxi-column
      caption="Culture"
      cellTemplate="cropTemplate"
      [allowEditing]="false"
      [editorOptions]="{
        searchEnabled: true,
        searchExpr: ['name'],
        dropDownOptions: { width: 250 }
      }"
      [calculateFilterExpression]="calculateFilterExpression"
      dataField="crop.name"
    >
      <div *dxTemplate="let cellInfo of 'cropTemplate'">
        <span
          [title]="cellInfo.data?.crop?.path_str || 'Non Disponible'"
          class="border-b border-dotted border-gray-700"
          >{{ cellInfo.data?.crop?.name || "NA" }}</span
        >
      </div>
      <dxo-lookup
        [dataSource]="crops | async"
        [allowClearing]="true"
        displayExpr="name"
        valueExpr="name"
      >
      </dxo-lookup>
    </dxi-column>

    <dxi-column
      caption="Superficie Cultivée"
      width="8%"
      format="#0.## Ha"
      dataType="number"
      [allowEditing]="false"
      cellTemplate="cropAreaTemplate"
      dataField="field_crop_cadastral_area"
    >
      <div *dxTemplate="let cellInfo of 'cropAreaTemplate'">
        {{ cellInfo.value ? cellInfo.value.toFixed(2) : '-' }} ({{
          ((cellInfo.data?.field_crop_percent || 0) * 100).toFixed(1)
        }}%)
      </div>
    </dxi-column>

    <dxi-column
      caption="Superficie Travaillée"
      dataType="number"
      format="#0.## Ha"
      dataField="working_area_ha"
      [allowEditing]="false"
    >
    </dxi-column>

    <dxi-column
      caption="Percentage"
      dataType="number"
      format="percent"
      [width]="100"
      dataField="working_area_percent"
      [allowEditing]="false"
    >
    </dxi-column>

    <!--<dxi-column
      caption="Cumule Percentage"
      format="percent"
      [calculateCellValue]="calculateCellValue">
    </dxi-column>-->
  </dxi-column>

  <dxi-column
    [visible]="columnFocusCurrentModes.includes('times')"
    name="times"
    caption="Durée (H:m)"
    [allowEditing]="false"
  >
    <dxi-column
      caption="Totale"
      dataField="total_duration"
      cellTemplate="tmp"
      [width]="80"
    >
      <span
        *dxTemplate="let d of 'tmp'"
        style="border-bottom: 1px dotted"
        [title]="durationToHoursStr(d)"
        >{{ durationToStr(d) }}</span
      >
    </dxi-column>
    <dxi-column
      caption="Travail Effectif"
      dataField="drive_working_duration"
      cellTemplate="tmp"
      [width]="120"
    >
      <span
        *dxTemplate="let d of 'tmp'"
        style="border-bottom: 1px dotted"
        [title]="durationToHoursStr(d)"
        >{{ durationToStr(d) }}</span
      >
    </dxi-column>
    <dxi-column
      caption="Arrêt Travail"
      dataField="stop_working_duration"
      cellTemplate="tmp"
      [width]="120"
    >
      <span
        *dxTemplate="let d of 'tmp'"
        style="border-bottom: 1px dotted"
        [title]="durationToHoursStr(d)"
        >{{ durationToStr(d) }}</span
      >
    </dxi-column>
    <dxi-column
      caption="Totale Trajet"
      dataField="total_road_duration"
      cellTemplate="tmp"
      [width]="120"
    >
      <span
        *dxTemplate="let d of 'tmp'"
        style="border-bottom: 1px dotted"
        [title]="durationToHoursStr(d)"
        >{{ durationToStr(d) }}</span
      >
    </dxi-column>
    <!--  start -->
    <dxi-column
      caption="Travail hors parcelle"
      dataField="working_out_field_move_duration"
      cellTemplate="tmp"
      [width]="120"
      [visible]="false"
    >
      <span
        *dxTemplate="let d of 'tmp'"
        style="border-bottom: 1px dotted"
        [title]="durationToHoursStr(d)"
        >{{ durationToStr(d) }}</span
      >
    </dxi-column>
    <dxi-column
      caption="Inactif hors parcelle"
      dataField="working_out_field_idle_duration"
      cellTemplate="tmp"
      [width]="120"
      [visible]="false"
    >
      <span
        *dxTemplate="let d of 'tmp'"
        style="border-bottom: 1px dotted"
        [title]="durationToHoursStr(d)"
        >{{ durationToStr(d) }}</span
      >
    </dxi-column>
    <dxi-column
      caption="Arrêt hors parcelle"
      dataField="working_out_field_off_duration"
      cellTemplate="tmp"
      [width]="120"
      [visible]="false"
    >
      <span
        *dxTemplate="let d of 'tmp'"
        style="border-bottom: 1px dotted"
        [title]="durationToHoursStr(d)"
        >{{ durationToStr(d) }}</span
      >
    </dxi-column>
    <!-- in field -->
    <dxi-column
      caption="Travail sur parcelle"
      dataField="working_in_field_move_duration"
      cellTemplate="tmp"
      [width]="120"
      [visible]="false"
    >
      <span
        *dxTemplate="let d of 'tmp'"
        style="border-bottom: 1px dotted"
        [title]="durationToHoursStr(d)"
        >{{ durationToStr(d) }}</span
      >
    </dxi-column>
    <dxi-column
      caption="Inactif sur parcelle"
      dataField="working_in_field_idle_duration"
      cellTemplate="tmp"
      [width]="120"
      [visible]="false"
    >
      <span
        *dxTemplate="let d of 'tmp'"
        style="border-bottom: 1px dotted"
        [title]="durationToHoursStr(d)"
        >{{ durationToStr(d) }}</span
      >
    </dxi-column>
    <dxi-column
      caption="Arrêt sur parcelle"
      dataField="working_in_field_off_duration"
      cellTemplate="tmp"
      [width]="120"
      [visible]="false"
    >
      <span
        *dxTemplate="let d of 'tmp'"
        style="border-bottom: 1px dotted"
        [title]="durationToHoursStr(d)"
        >{{ durationToStr(d) }}</span
      >
    </dxi-column>
    <!-- road  -->
    <dxi-column
      caption="Travail sur trajet"
      dataField="road_move_duration"
      cellTemplate="tmp"
      [width]="120"
      [visible]="false"
    >
      <span
        *dxTemplate="let d of 'tmp'"
        style="border-bottom: 1px dotted"
        [title]="durationToHoursStr(d)"
        >{{ durationToStr(d) }}</span
      >
    </dxi-column>
    <dxi-column
      caption="Inactif sur trajet"
      dataField="road_idle_duration"
      cellTemplate="tmp"
      [width]="120"
      [visible]="false"
    >
      <span
        *dxTemplate="let d of 'tmp'"
        style="border-bottom: 1px dotted"
        [title]="durationToHoursStr(d)"
        >{{ durationToStr(d) }}</span
      >
    </dxi-column>
    <dxi-column
      caption="Arrêt sur trajet"
      dataField="road_off_duration"
      cellTemplate="tmp"
      [width]="120"
      [visible]="false"
    >
      <span
        *dxTemplate="let d of 'tmp'"
        style="border-bottom: 1px dotted"
        [title]="durationToHoursStr(d)"
        >{{ durationToStr(d) }}</span
      >
    </dxi-column>
    <!--  end -->
  </dxi-column>

  <dxi-column
    [visible]="columnFocusCurrentModes.includes('speed')"
    name="speed"
    caption="Vitesse"
    [allowEditing]="false"
  >
    <dxi-column
      caption="Moyenne (km/h)"
      dataType="number"
      format="#0.##"
      dataField="working_in_field_speed_avg"
    >
    </dxi-column>

    <dxi-column
      caption="Maximale (km/h)"
      dataType="number"
      format="#0.##"
      dataField="working_in_field_speed_max"
    >
    </dxi-column>

    <dxi-column
      caption="Débit (Ha/h)"
      dataType="number"
      format="#0.##"
      dataField="working_hectare_per_hour"
      name="working_hectare_per_hour"
    >
    </dxi-column>
    <dxi-column
      caption="Ha/h (mot)"
      dataType="number"
      format="#0.##"
      name="motor_hectare_per_hour"
      [calculateCellValue]="motorHectarPerHour"
    >
    </dxi-column>
  </dxi-column>

  <dxi-column
    [visible]="columnFocusCurrentModes.includes('pressure')"
    name="pressure"
    caption="Pression"
    [allowEditing]="false"
  >
    <dxi-column
      caption="Maximale (Bar)"
      dataType="number"
      format="#0.##"
      dataField="pressure_max"
      name="pressure_max"
    >
    </dxi-column>

    <dxi-column
      caption="Moyenne (Bar)"
      dataType="number"
      format="#0.##"
      dataField="pressure_avg"
      name="pressure_avg"
    >
    </dxi-column>

    <dxi-column
      caption="Minimale (Bar)"
      dataType="number"
      format="#0.##"
      dataField="pressure_min"
      name="pressure_min"
    >
    </dxi-column>
  </dxi-column>

  <dxi-column
    [visible]="columnFocusCurrentModes.includes('fuel')"
    name="fuel"
    caption="Carburant"
    [allowEditing]="false"
  >
    <dxi-column
      caption="Totale (L)"
      format="#0.##"
      dataField="metrics.fuel_total_consumption_all"
      name="fuel_total_consumption_all"
    ></dxi-column>
    <dxi-column
      caption="Litres / h"
      format="#0.##"
      dataField="metrics.fuel_hourly_consumption_rate_avg_all"
      name="fuel_hourly_consumption_rate"
    ></dxi-column>
    <dxi-column
      caption="Litres / ha"
      format="#0.##"
      dataField="fuel_total_consumption_per_hectare"
      name="fuel_per_hectare"
      [calculateCellValue]="literPerHour"
    ></dxi-column>
    <dxi-column
      caption="Heures Moteurs"
      format="#0.##"
      dataField="metrics.engine_working_time_all"
      name="engine_working_time"
      cellTemplate="tmp"
    >
      <span
        *dxTemplate="let d of 'tmp'"
        style="border-bottom: 1px dotted"
        [title]="durationToHoursStr(d)"
        >{{ durationToStr(d) }}</span
      >
    </dxi-column>
    <dxi-column
      caption="CO2 Émis (Kg)"
      format="#0.##"
      name="co2_emission"
      [calculateCellValue]="CO2Emission"
    ></dxi-column>
    <dxi-column
      caption="Temperature"
      format="#0.##"
      dataField="metrics.fuel_temperature_avg_all"
    ></dxi-column>
  </dxi-column>

  <!-- Accuracy Rating Column (Both Trailer and Reconstructed Interventions) -->
  <dxi-column
    caption="Précision des Données"
    [width]="220"
    dataField="data_accuracy_rating"
    cellTemplate="accuracyRatingTemplate"
    editCellTemplate="accuracyRatingEditor"
    [setCellValue]="setRatingValue"
    [allowEditing]="canEditRating"
    [visible]="columnFocusCurrentModes.includes('trailer')">
    <div *dxTemplate="let cellInfo of 'accuracyRatingTemplate'">
      <!-- Show rating for trailer interventions -->
      <lib-badge *ngIf="cellInfo.value && isTrailer(cellInfo.data)" [color]="getAccuracyRatingColor(cellInfo.value)">
        {{getAccuracyRatingLabel(cellInfo.value)}}
      </lib-badge>
      <span *ngIf="(!cellInfo.value || cellInfo.value === null || cellInfo.value === '') && isTrailer(cellInfo.data)" class="text-gray-400 text-sm">Non évalué</span>
      <!-- Show rating for reconstructed interventions (mapped from validation_accuracy) -->
      <lib-badge *ngIf="cellInfo.value && isReconstructed(cellInfo.data)" [color]="getAccuracyRatingColor(cellInfo.value)">
        {{getAccuracyRatingLabel(cellInfo.value)}}
      </lib-badge>
      <span *ngIf="(!cellInfo.value || cellInfo.value === null || cellInfo.value === '') && isReconstructed(cellInfo.data)" class="text-gray-400 text-sm">Non évalué</span>
    </div>
    <div *dxTemplate="let cellInfo of 'accuracyRatingEditor'">
      <dx-select-box
        *ngIf="isTrailer(cellInfo.data) && (!cellInfo.value || cellInfo.value === null || cellInfo.value === '')"
        [dataSource]="accuracyRatingOptions"
        displayExpr="label"
        valueExpr="value"
        [value]="cellInfo.value"
        (onValueChanged)="cellInfo.setValue($event.value)"
        [searchEnabled]="false"
        placeholder="Sélectionner une option">
      </dx-select-box>
    </div>
  </dxi-column>

  <!-- Reconstructed Intervention Columns -->
  <dxi-column
    caption="Statut"
    [width]="120"
    dataField="status"
    [visible]="false"
    [allowEditing]="false">
  </dxi-column>

  <dxi-column
    caption="Score"
    [width]="80"
    dataField="confidence_score"
    [visible]="false"
    [allowEditing]="false">
  </dxi-column>

  <dxi-column
    caption="Note de Validation"
    [width]="140"
    cellTemplate="accuracyRatingTemplateReconstructed"
    dataField="accuracy_rating"
    [visible]="false">
    <div *dxTemplate="let cellInfo of 'accuracyRatingTemplateReconstructed'">
      <lib-badge *ngIf="cellInfo.value && isReconstructed(cellInfo.data)" [color]="getAccuracyRatingColor(cellInfo.value)">
        {{cellInfo.value}}/10
      </lib-badge>
    </div>
  </dxi-column>

  <dxi-column
    caption="Raison de Rejet"
    [width]="200"
    cellTemplate="rejectionReasonTemplate"
    dataField="rejection_reason"
    [visible]="false">
    <div *dxTemplate="let cellInfo of 'rejectionReasonTemplate'">
      <lib-badge *ngIf="cellInfo.value && isReconstructed(cellInfo.data)" color="red">
        {{cellInfo.value}}
      </lib-badge>
    </div>
  </dxi-column>

  <dxi-column [visible]="false" caption="Domaine" [allowEditing]="false">
    <dxi-column
      caption="Nom"
      dataField="domain_name"
      [allowEditing]="false"
      [editorOptions]="{
        searchEnabled: true,
        searchExpr: ['name'],
        dropDownOptions: { width: 250 }
      }"
    >
      <dxo-lookup
        [dataSource]="domains"
        [allowClearing]="true"
        displayExpr="name"
        valueExpr="name"
      >
      </dxo-lookup>
    </dxi-column>
    <dxi-column
      caption="BU"
      dataField="business_unit_name"
      [allowEditing]="false"
      [editorOptions]="{
        searchEnabled: true,
        searchExpr: ['name'],
        dropDownOptions: { width: 250 }
      }"
    >
      <dxo-lookup
        [dataSource]="bu"
        [allowClearing]="true"
        displayExpr="name"
        valueExpr="name"
      >
      </dxo-lookup>
    </dxi-column>
  </dxi-column>

  <dxo-selection selectAllMode="page" mode="multiple"></dxo-selection>

  <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

  <dxo-group-panel [visible]="false"></dxo-group-panel>

  <dxo-export
    [enabled]="true"
    fileName="liste-interventions-parcelles"
    [allowExportSelectedData]="true"
  ></dxo-export>

  <dxo-sorting mode="multiple"></dxo-sorting>

  <dxo-paging [pageSize]="25"></dxo-paging>

  <dxo-pager
    [showPageSizeSelector]="true"
    [allowedPageSizes]="[25, 50, 100]"
    [showInfo]="true"
  >
  </dxo-pager>

  <dxo-filter-row [visible]="true"></dxo-filter-row>

  <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>

  <div *dxTemplate="let data of 'addButtonTemplate'">
    <dx-button
      icon="plus"
      type="default"
      stylingMode="text"
      hint="Ajouter une intervention manuelle"
      (onClick)="openManualInterventionDialog()"
      [disabled]="!canAdd">
    </dx-button>
  </div>

  <dxo-header-filter [visible]="true"></dxo-header-filter>

  <dxo-summary>
    <dxi-total-item
      column="working_area_ha"
      valueFormat="#0.##"
      summaryType="sum"
    >
    </dxi-total-item>
    <dxi-total-item
      column="working_area_percent"
      valueFormat="percent"
      summaryType="sum"
    >
    </dxi-total-item>
    <dxi-total-item
      column="total_duration"
      [customizeText]="durationToStr"
      summaryType="sum"
    >
    </dxi-total-item>
    <dxi-total-item
      column="total_working_duration"
      [customizeText]="durationToStr"
      summaryType="sum"
    >
    </dxi-total-item>
    <dxi-total-item
      column="stop_working_duration"
      [customizeText]="durationToStr"
      summaryType="sum"
    >
    </dxi-total-item>
    <dxi-total-item
      column="total_road_duration"
      [customizeText]="durationToStr"
      summaryType="sum"
    >
    </dxi-total-item>
    <dxi-total-item
      column="working_in_field_speed_max"
      valueFormat="#0.##"
      summaryType="max"
    >
    </dxi-total-item>
    <dxi-total-item
      column="working_in_field_speed_avg"
      valueFormat="#0.##"
      summaryType="avg"
    >
    </dxi-total-item>
    <dxi-total-item
      column="working_hectare_per_hour"
      valueFormat="#0.##"
      summaryType="avg"
    >
    </dxi-total-item>
    <dxi-total-item
      column="total_fuel_consumption"
      valueFormat="#0.##"
      summaryType="sum"
    >
    </dxi-total-item>
    <dxi-total-item
      column="fuel_consumption_per_hectare"
      valueFormat="#0.##"
      summaryType="avg"
    >
    </dxi-total-item>
  </dxo-summary>

  <div *dxTemplate="let data of 'columnFocusTabsTemplate'">
    <dx-button-group
      [items]="columnFocusTabsModes"
      keyExpr="id"
      stylingMode="text"
      selectionMode="multiple"
      [(selectedItemKeys)]="columnFocusCurrentModes"
      (onSelectionChanged)="columnFocusSelectionChanged($event)"
    >
    </dx-button-group>
  </div>

  <dxo-editing
    mode="cell"
    [allowUpdating]="canEdit"
    [selectTextOnEditStart]="true"
  >
  </dxo-editing>
</dx-data-grid>

<dx-popover
  [target]="tagDetailsEl"
  position="top"
  title="Information de la carte"
  [showTitle]="true"
  hideEvent="mouseleave"
  [width]="300"
  [(visible)]="tagDetailsVisible"
>
  <div *dxTemplate="let data = model; of: 'content'">
    <!--<div class="details-list">
      <div>Catégorie</div>
      <div>{{current.tag_details.category.name}}</div>
      <ng-container *ngFor="let attr of current.tag_details.attributes">
        <div>{{attr.name}}</div>
        <div>{{attr.value}}</div>
      </ng-container>
    </div>-->
  </div>
</dx-popover>

<app-fields-interventions-report
  *ngIf="current && isTrailer(current)"
  [(visible)]="reportVisible"
  [intervention]="current"
  [request]="request"
>
</app-fields-interventions-report>

<app-reconstructed-intervention-report
  *ngIf="selectedReconstructedIntervention"
  [(visible)]="reconstructedReportVisible"
  [intervention]="selectedReconstructedIntervention"
  [request]="{ from: request.from, to: request.to, isToday: request.isToday }"
>
</app-reconstructed-intervention-report>

<app-validate-dialog
  #validateDialog
  (onValidate)="onValidateSuccess()">
</app-validate-dialog>

<app-reject-dialog
  #rejectDialog
  (onReject)="onRejectSuccess()">
</app-reject-dialog>

<app-rating-dialog
  #ratingDialog
  (onRating)="onRatingSuccess()">
</app-rating-dialog>

<app-manual-intervention-dialog
  #manualInterventionDialog
  (onCreated)="onManualInterventionCreated()">
</app-manual-intervention-dialog>
